module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "app-content-body"
  }, [_c('div', {
    staticClass: "wrapper-md",
    attrs: {
      "ng-controller": "JVectorMapDemoCtrl"
    }
  }, [_c('div', {
    staticClass: "panel b-a"
  }, [_c('div', {
    staticClass: "panel-heading b-b b-light"
  }, [_vm._v("Excluir Item")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_vm._v("\n                    Lorem Isum\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('button', {
    staticClass: "btn m-b-xs w-xs btn-default"
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn m-b-xs w-xs btn-danger"
  }, [_vm._v("Excluir")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41c8be15","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/utilitarios/components/Excluir.vue
// module id = 1641
// module chunks = 17